import type { User, WorkspaceIdentity } from './types'

export const mockWorkspace: WorkspaceIdentity = {
  id: 'ws-vds',
  brandName: 'Rager',
  handle: '@vds_workspace',
}

export const mockUser: User = {
  id: 'user-chang',
  fullName: 'Chang Vidal',
  initials: 'C',
  role: 'Plano Pesquisa',
  email: 'changfindaway@example.com',
}
